import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from '../../components/Auth/_store/alert.module'
import { authentication } from '../../components/Auth/_store/authentication.module'
import { users } from '../../components/Auth/_store/users.module'
import preloadedData from './preloadedDataStore'
import { authStore } from './authHelperStore'
import createPersistedState from 'vuex-persistedstate'
import { opDataStore } from './operationalData'

Vue.use(Vuex)

export const store = new Vuex.Store({
  name: 'store',
  modules: {
    alert,
    authentication,
    users,
    preloadedData,
    authStore,
    opDataStore
  },
  plugins: [createPersistedState()]
})
